import { render, staticRenderFns } from "./insight-card.component.vue?vue&type=template&id=74931aea&scoped=true"
import script from "./insight-card.component.vue?vue&type=script&lang=ts"
export * from "./insight-card.component.vue?vue&type=script&lang=ts"
import style0 from "./insight-card.component.vue?vue&type=style&index=0&id=74931aea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74931aea",
  null
  
)

export default component.exports